function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
const GeneralTooltip = ({
  title,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    title: title
  }, props), children);
};
export { GeneralTooltip };